import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'
import axios from 'axios'
import { login as apiLogin, logout as apiLogout } from '@/api/Authentication'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(null)

  const isLoggedIn = computed(() => !!token.value)

  // 同步 axios 全域 Authorization header（含 persist 還原後立即生效）
  watch(token, (t) => {
    if (t) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + t
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }, { immediate: true })

  /** 登入：呼叫 API、解析 token，回傳原始回應供 view 顯示訊息 */
  async function login(credentials) {
    const rep = await apiLogin(credentials)
    const sc = rep?.data
    if (sc?.code === 200 && sc?.token) {
      token.value = sc.token
    }
    return rep
  }

  /** 僅清除本地 token（給 401 攔截器使用，不呼叫 API） */
  function clearToken() {
    token.value = null
  }

  /** 登出：呼叫 API 後清除本地 token */
  async function logout() {
    try {
      await apiLogout()
    } finally {
      clearToken()
    }
  }

  return { token, isLoggedIn, login, clearToken, logout }
}, { persist: true })
